export const STUDIO_UNIT_TYPE_GUID = "F0E8BA29-D402-4BE6-849D-29A5126E3E4A";
export const JOINED_STUDIO_UNIT_TYPE_GUID =
  "32606AFE-0134-437A-8316-0CC71B4754F4";
export const ONE_BEDROOM_UNIT_TYPE_GUID =
  "F6D130C7-E6EF-4F52-B789-39E1EE63444E";
export const TWO_BEDROOM_UNIT_TYPE_GUID =
  "4FD1D51B-85F8-41E1-B81D-D6AFF8600962";

const singleApplicantFallbackUnitTypes: Set<string> = new Set([
  STUDIO_UNIT_TYPE_GUID.toLowerCase(),
  JOINED_STUDIO_UNIT_TYPE_GUID.toLowerCase(),
  ONE_BEDROOM_UNIT_TYPE_GUID.toLowerCase(),
]);

const coApplicantFallbackUnitTypes: Set<string> = new Set([
  ONE_BEDROOM_UNIT_TYPE_GUID.toLowerCase(),
  TWO_BEDROOM_UNIT_TYPE_GUID.toLowerCase(),
]);

/**
 * Unit types a co-applicant (couple) household cannot occupy and should never
 * be offered or have persisted into their room preference. A studio (or joined
 * studio) is single-occupancy only.
 */
export const coApplicantIneligibleUnitTypes: Set<string> = new Set([
  STUDIO_UNIT_TYPE_GUID.toLowerCase(),
  JOINED_STUDIO_UNIT_TYPE_GUID.toLowerCase(),
]);

/**
 * Whether the given unit type leaf GUID may be occupied by a household with a
 * co-applicant (a couple). Studios are excluded.
 */
export const isUnitTypeEligibleForCoApplicant = (
  unitTypeGuid: string,
): boolean => !coApplicantIneligibleUnitTypes.has(unitTypeGuid.toLowerCase());

export const hasMatchingUnitTypePreference = (
  unitTypeGuid: string,
  roomPreferenceV2: string[] | null | undefined,
  roomPreference: string[] | null | undefined,
  hasCoApplicant: boolean,
): boolean => {
  const roomPreferenceV2List = roomPreferenceV2 ?? [];
  const hasLegacyRoomPreference = (roomPreference?.length ?? 0) > 0;
  const hasNoRoomPreference =
    roomPreferenceV2List.length === 0 && !hasLegacyRoomPreference;

  if (!hasNoRoomPreference) {
    return roomPreferenceV2List.includes(unitTypeGuid);
  }

  const normalizedGuid = unitTypeGuid.toLowerCase();
  return hasCoApplicant
    ? coApplicantFallbackUnitTypes.has(normalizedGuid)
    : singleApplicantFallbackUnitTypes.has(normalizedGuid);
};
